import { render, staticRenderFns } from "./ModuleSwitch.vue?vue&type=template&id=38989f44"
import script from "./ModuleSwitch.vue?vue&type=script&lang=ts"
export * from "./ModuleSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ModuleSwitch.vue?vue&type=style&index=0&id=38989f44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports